import LazyLoadImage from '@bnnvara/lazy-load';
import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';
export function ImageCard({
  src,
  alt: altPostfix,
  isLazyLoaded,
  isSquare,
  darken,
  children
}) {
  const alt = `Afbeelding van ${altPostfix}`;
  return /*#__PURE__*/React.createElement(S.Container, {
    isSquare: isSquare
  }, /*#__PURE__*/React.createElement(S.Background, null, isLazyLoaded ? /*#__PURE__*/React.createElement(LazyLoadImage, {
    as: S.Image,
    src: src,
    dark: darken,
    alt: alt
  }) : /*#__PURE__*/React.createElement(S.Image, {
    src: src,
    alt: alt
  })), children);
}
ImageCard.defaultProps = {
  children: null,
  darken: false,
  isLazyLoaded: false,
  isSquare: false
};
ImageCard.propTypes = {
  alt: PropTypes.string.isRequired,
  children: PropTypes.node,
  darken: PropTypes.bool,
  isLazyLoaded: PropTypes.bool,
  isSquare: PropTypes.bool,
  src: PropTypes.string.isRequired
};